// @flow @format
import {handleActions} from 'lib/redux-actions';

export type State = {
	isLoggedIn: boolean,
	token: string,
	user: string,
	server: string,
	group: number,
};

type LoginAction = {
	type: string,
	payload: {
		user: string,
		token: string,
		server: string,
		group: number,
	},
};

type LogoutAction = {
	type: string,
};

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const CLOSE_SESSION = 'CLOSE_SESSION';

export function login(
	user: string,
	token: string,
	server: string,
	group: number,
): LoginAction {
	return {type: LOGIN, payload: {user, token, server, group}};
}

export function logout(): LogoutAction {
	return {type: LOGOUT};
}

export function closeSession(): LogoutAction {
	return {type: CLOSE_SESSION};
}

export const initialState = {
	isLoggedIn: false,
	token: '',
	user: '',
	group: 0,
	server: '',
};

const reducer = handleActions(
	{
		[LOGIN]: (state: State, action: LoginAction): State => {
			const nextState = {...state, ...action.payload, isLoggedIn: true};

			window.localStorage.setItem(
				'cloner_session',
				JSON.stringify(nextState),
			);

			return nextState;
		},
		[CLOSE_SESSION]: (): State => {
			window.localStorage.removeItem('cloner_session');

			return initialState;
		},
	},
	initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/session.js